import { handleError } from 'common/utils/util.errors';
import { getProjectSummary } from '../components/project/project.api';
import React from 'react';
import { useQuery } from 'react-query';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { LinearProgress } from '@mui/material';
import dataKeys from 'common/react-query/data-keys';
import { ROUTES } from 'common/constants/urls';
import { useAppContext } from 'common/AppContext';
import { ProjectWrapper } from '../components/project/ProjectWrapper';

const Project: React.FC = () => {
  const navigate = useNavigate();
  const { setPageHeaderText } = useAppContext();
  const { projectId } = useParams();
  const location = useLocation();

  // Get optional PayApp data passed via navigate

  const {
    data: projectSummary,
    isLoading: isLoadingProjectSummary,
    isError: isErrorProjectSummary,
    error: errorProjectSummary,
  } = useQuery([dataKeys.project, projectId], () => getProjectSummary(projectId ?? ''), {
    enabled: !!projectId,
  });

  React.useEffect(() => {
    if (projectSummary?.projectTitle) {
      const label = projectSummary.projectNumber?.trim()
        ? `${projectSummary.projectNumber} ${projectSummary.projectTitle}`
        : projectSummary.projectTitle;
      setPageHeaderText(label);
    }
    return () => {
      setPageHeaderText('');
    };
  }, [setPageHeaderText, projectSummary?.projectTitle, projectSummary?.projectNumber]);

  const clearLocationState = () => {
    navigate(location.pathname, { replace: true });
  };

  if (!projectId) {
    navigate(ROUTES.NOT_FOUND);
    return null;
  }

  if (isErrorProjectSummary) {
    handleError(errorProjectSummary);
    navigate(ROUTES.NOT_FOUND);
    return null;
  }

  if (isLoadingProjectSummary) return <LinearProgress />;
  if (!projectSummary) {
    navigate(ROUTES.NOT_FOUND);
    return null;
  }

  return (
    <ProjectWrapper
      projectId={projectId}
      projectSummary={projectSummary}
      isLoadingProjectSummary={isLoadingProjectSummary}
      isErrorProjectSummary={isErrorProjectSummary}
      errorProjectSummary={errorProjectSummary}
    />
  );
};

export default Project;
